import { CycleSelector } from '@wix/checkout-components';
import { Action } from '../../types';
import { CheckoutActionNames } from './Checkout.actions';

export interface CheckoutState {
  orderPageEventAggregator: string;
  alternativeCycle: CycleSelector | null;
  showCustomFooter: boolean;
}

export const checkoutReducerInitialState: CheckoutState = {
  orderPageEventAggregator: '',
  alternativeCycle: null,
  showCustomFooter: false,
};

export function CheckoutReducer(state: CheckoutState, action: Action) {
  switch (action.type) {
    case CheckoutActionNames.SET_ORDER_PAGE_EVENT_AGGREGATOR:
      return { ...state, orderPageEventAggregator: action.payload };
    case CheckoutActionNames.SET_ALTERNATIVE_CYCLE:
      return { ...state, alternativeCycle: action.payload };
    case CheckoutActionNames.SET_SHOW_CUSTOM_FOOTER:
      return { ...state, showCustomFooter: action.payload };
    default:
      return state;
  }
}
